import {MenuOption} from '@lexical/react/LexicalTypeaheadMenuPlugin'
import {PopoverMenuItemType} from "../../../popover-menu/popover-menu/const"

export class InternalLinkOption extends MenuOption {

    id?             : ID
    type            : PopoverMenuItemType
    label           : string                        // label in menu
    iconComponent?  : any                           // iconComponent in menu
    keywords        : Array<string>                 // extra searching keywords
    options?        : InternalLinkOption[]
    action?         : (queryString: string) => void // action on option select

    constructor(
        label   : string,
        config : {
            id?             : ID
            type?           : PopoverMenuItemType
            iconComponent?  : any
            keywords?       : Array<string>
            options?        : InternalLinkOption[]
            action?         : (queryString: string) => void
        },
    ) {
        super(label)
        this.id             = config.id
        this.type           = config.type || PopoverMenuItemType.ITEM
        this.label          = label
        this.keywords       = config.keywords || []
        this.iconComponent  = config.iconComponent
        this.options        = config.options
        this.action         = config.action ? config.action.bind(this) : undefined
    }
}
